const ROUTES = {
  SAMPLE: "/sample",

  // App version
  APP_VERSION: "/app-versions",

  // User
  LANDING: "/",
  LOGIN: "/login",
  FORGET_PASSWORD: "/forgetPassword",
  RESET_PASSWORD: "/resetPassword/:param",
  CHANGE_PASSWORD: "/change-password",

  // Location
  REGION: "/regions",
  TOWNSHIP: "/townships",
  VILLAGE_TRACT: "/village-tracts",
  VILLAGE: "/villages",
  CLUSTER: "/clusters",

  // Manage Users
  PORTAL_USER: "/portal-users",
  OFFICE: "/offices",
  COMMITTEE: "/committees/*",
  COMMITTEE_DETAIL: "/committees/detail",
  COMMITTEE_MEMBER_DETAIL: "/committees/detail/member",
  COMMITTEE_DEPOSIT_DETAIL: "/committees/detail/deposit",
  MEMBER: "/members/*",
  MEMBER_DETAIL: "/members/detail",
  SHOP: "/shops",
  DONOR: "/donors",

  // FundReceiving
  FUNDRECEIVING: "/fund-contracts",

  // FundHandingOver
  FUNDHANDINGOVER: "/fund-transfers",

  // Deposit
  DEPOSIT: "/deposits",

  // Permission
  ROLES: "/portalUserRoles",
  SCHEMA: "/schema",

  //Dashboard
  FIN_DASHBOARD: "/finance-dashboard",
  FIN_HO_DASHBOARD: "/finance-HO-dashboard",
  ADMIN_DASHBOARD: "/admin-dashboard",
  ECCO_DASHBOARD: "/ecco-dashboard",

  // FundReceivingInvoices
  FUND_RECEIVING_INVOICES: "/fundReceivingInvoices",
  FUND_RECEIVING_INVOICES_DETAIL:
    "/fundReceivingInvoices/:fund_receiving_invoice_id",

  // FundAllocation
  FUND_ALLOCATION: "/fundAllocation",
  FUND_ALLOCATION_DETAIL: "/fundAllocation/:fund_allocation_id",

  // Loan
  LOAN: "/loans",
  LOAN_DETAIL: "/loans/:loan_id",

  // Settlement
  SETTLEMENT: "/settlement",

  // Invoice
  INVOICE: "/invoices",

  // Product Category
  CATALOG: "/product-list",
  CATALOG_LOG: "/product-list/:product_id/logs",

  // Product Category
  CATEGORY: "/product-categories",

  // Product Brand
  BRAND: "/product-brands",

  // Revenue Transfers
  REVENUETRANSFERS: "/revenue-transfers",
  REVENUETRANSFERS_DETAIL: "/revenue-transfers/:revenue_transfers_id",

  // Action Log
  ACTION_LOG: "/action-logs",

  //Analytics 
  ANALYTICS_REPORT: "/analytics-report",
  ANALYTICS_LOG : "/analytics-logs",
  ARTICLE_LOG: "/articles/:article_id/logs",

  // Article
  ARTICLE: "/articles",
  ARTICLE_CREATE: "/articles/create",
  ARTICLE_DETAIL: "/articles/:article_id",
  ARTICLE_VIDEO_CREATE: "/articles/video/create",
  ARTICLE_VIDEO_DETAIL: "/articles/video/:article_id",

  // Language
  LANGUAGE: "/languages",
  LANGUAGE_CREATE: "/languages/create",
  LANGUAGE_DETAIL: "/languages/:language_id",

  // check top
  OTP: "/otp",

  // reset-password
  RESET_PASSWORD_BY_AUTHENTICATOR: "/reset-password",

  // Ecommerce Order
  ECOMMERCEORDER: "/ecommerce-orders",
  ECOMMERCEORDER_CREATE: "/ecommerce-orders/create",
  ECOMMERCEORDER_DETAIL: "/ecommerce-orders/:article_id",

  // Data Export
  DATA_EXPORT: "/data-exports",

  // Static Page
  STATIC_PAGE: "/static-pages",

  // Maintenance Page
  MAINTENANCE: "/maintenance",

  APP_SETTING: "/app-setting",
};
export default ROUTES;
